import React, { useEffect, useState } from "react";
import "../newleaderboard.css";
import azureRank from "../assets/azureRank.svg";
import crystalRank from "../assets/crystalRank.svg";
import eclipseRank from "../assets/eclipseRank.svg";
import sapphireRank from "../assets/sapphireRank.svg";
import usdt from "../../../assets/usdt.svg";
import "../../Leaderboard/leaderboard.css";
import { NavLink } from "react-router-dom";
import rightArrow from "../assets/rightArrow.svg";
import Countdown from "react-countdown";
import { shortAddress } from "../../../hooks/shortAddress";
import tooltip from "../../../assets/tooltip.svg";
import OutsideClickHandler from "react-outside-click-handler";

const renderer = ({ days, hours }) => {
  return (
    <span className="progress-reset-time">
      {days}d {hours}h
    </span>
  );
};

const ProgressView = ({ rank, xpleaderboards }) => {
  const [leaderboard, setLeaderboard] = useState("azure");
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [tooltipInfo, setTooltipInfo] = useState(false);

  useEffect(() => {
    setLeaderboardData(xpleaderboards?.board1);
  }, [xpleaderboards]);

  const baseDate = new Date("2025-12-22T09:00:00");

  return (
    <div className="container-fluid leaderboard-wrapper py-3">
      <div className="d-flex px-3 flex-column gap-2">
        <NavLink
          to={"/leaderboard"}
          className="rank-back-button  d-flex justify-content-center align-items-center"
        >
          <img
            src={rightArrow}
            style={{ transform: "rotate(180deg)" }}
            width={15}
            height={15}
            alt=""
          />
        </NavLink>
        <NavLink
          to={"/leaderboard/rank"}
          state={{ rank: 0 }}
          style={{ textDecoration: "none" }}
          className="progress-rank-wrapper p-3 w-100 d-flex align-items-center gap-2"
        >
          {rank === 1 && (
            <div className="current-rank-wrapper p-1 d-flex align-items-center justify-content-center">
              <span className="current-rank-text">Current</span>
            </div>
          )}
          <img src={sapphireRank} className="progress-rank-image" alt="" />
          <div className="d-flex flex-column gap-2">
            <h6 className="progress-rank-title mb-0">Sapphire Spark</h6>
            <span className="progress-rank-desc">
              Everyone starts here. Begin your journey by completing the first
              task.
            </span>
          </div>
        </NavLink>
        <NavLink
          to={"/leaderboard/rank"}
          state={{ rank: 1 }}
          style={{ textDecoration: "none" }}
          className="progress-rank-wrapper p-3 w-100 d-flex align-items-center gap-2"
        >
          {rank === 2 && (
            <div className="current-rank-wrapper p-1 d-flex align-items-center justify-content-center">
              <span className="current-rank-text">Current</span>
            </div>
          )}
          <img src={azureRank} className="progress-rank-image" alt="" />
          <div className="d-flex flex-column gap-2">
            <h6 className="progress-rank-title mb-0">Azure Crest</h6>
            <span className="progress-rank-desc">
              Unlock this badge to qualify for the first raffle draw.
            </span>
          </div>
        </NavLink>
        <NavLink
          to={"/leaderboard/rank"}
          state={{ rank: 2 }}
          style={{ textDecoration: "none" }}
          className="progress-rank-wrapper p-3 w-100 d-flex align-items-center gap-2"
        >
          {rank === 3 && (
            <div className="current-rank-wrapper p-1 d-flex align-items-center justify-content-center">
              <span className="current-rank-text">Current</span>
            </div>
          )}
          <img src={crystalRank} className="progress-rank-image" alt="" />
          <div className="d-flex flex-column gap-2">
            <h6 className="progress-rank-title mb-0">Crystal Crown</h6>
            <span className="progress-rank-desc">
              Unlock this badge to qualify for the premium raffle draw.
            </span>
          </div>
        </NavLink>
        <NavLink
          to={"/leaderboard/rank"}
          state={{ rank: 3 }}
          style={{ textDecoration: "none" }}
          className="progress-rank-wrapper p-3 w-100 d-flex align-items-center gap-2"
        >
          {rank === 4 && (
            <div className="current-rank-wrapper p-1 d-flex align-items-center justify-content-center">
              <span className="current-rank-text">Current</span>
            </div>
          )}
          <img src={eclipseRank} className="progress-rank-image" alt="" />
          <div className="d-flex flex-column gap-2">
            <h6 className="progress-rank-title mb-0">Eclipse Core</h6>
            <span className="progress-rank-desc">
              The top-tier badge. Hit the goal and claim guaranteed rewards
              directly.
            </span>
          </div>
        </NavLink>
      </div>
      <div className="mt-4 d-flex align-items-end justify-content-between w-100 px-3">
        <div className="d-flex align-items-center gap-2">
          <h6 className="progress-winners-title mb-0">Weekly Winners</h6>
          <div className="position-relative d-flex align-items-center justify-content-center">
            <img
              src={tooltip}
              width={20}
              height={20}
              style={{ cursor: "pointer" }}
              alt=""
              onClick={() => setTooltipInfo(true)}
            />
            <OutsideClickHandler onOutsideClick={() => setTooltipInfo(false)}>
              <div
                className={`daily-session-tooltip-content-wrapper ${
                  tooltipInfo && "daily-session-tooltip-active"
                }`}
                style={{ width: "200px" }}
              >
                <span>Showing winners between December 8 and December 14</span>
              </div>
            </OutsideClickHandler>
          </div>
        </div>
        <div className="d-flex align-items-end gap-1">
          <span className="progress-reset-text">Reset in</span>
          <Countdown renderer={renderer} date={baseDate} />
        </div>
      </div>
      <div className="mt-2 d-flex flex-column px-3">
        <div className="progress-leaderboard-tabs-wrapper w-100 position-relative d-flex align-items-center">
          <div
            className={`progress-leaderboard-active ${
              leaderboard === "crystal"
                ? "move-tab-1"
                : leaderboard === "eclipse"
                ? "move-tab-2"
                : ""
            } d-flex align-items-center justify-content-center`}
          >
            <h6
              className="progress-leaderboard-tab-title mb-0"
              style={{ color: "#fff" }}
            >
              {leaderboard === "crystal"
                ? "Crystal Crown"
                : leaderboard === "eclipse"
                ? "Eclipse Core"
                : "Azure Crest"}
            </h6>
          </div>
          <div
            className={`progress-leaderboard-tab d-flex align-items-center justify-content-center`}
            onClick={() => {
              setLeaderboard("azure");
              setLeaderboardData(xpleaderboards?.board1);
            }}
          >
            <h6 className="progress-leaderboard-tab-title mb-0">Azure Crest</h6>
          </div>
          <div
            className={`progress-leaderboard-tab d-flex align-items-center justify-content-center`}
            onClick={() => {
              setLeaderboard("crystal");
              setLeaderboardData(xpleaderboards?.board2);
            }}
          >
            <h6 className="progress-leaderboard-tab-title mb-0">
              Crystal Crown
            </h6>
          </div>
          <div
            className={`progress-leaderboard-tab d-flex align-items-center justify-content-center`}
            onClick={() => {
              setLeaderboard("eclipse");
            }}
          >
            <h6 className="progress-leaderboard-tab-title mb-0">
              Eclipse Core
            </h6>
          </div>
        </div>
        <div className="progress-leaderboard d-flex flex-column">
          {leaderboardData === undefined || leaderboardData?.length === 0 ? (
            <div className="d-flex h-100 w-100 justify-content-center align-items-center">
              <span className="eclipse-winners-desc">
                Winners will be displayed after the first week ends
              </span>
            </div>
          ) : (
            <>
              {leaderboard === "eclipse" ? (
                <>
                  {rank === 4 ? (
                    <div className="d-flex flex-column align-items-center justify-content-center gap-2 w-100 mt-5">
                      <h6 className="eclipse-winners-text mb-0">
                        🎉 Congrats! 🎉
                      </h6>
                      <span className="eclipse-winners-desc">
                        You've secured the top-tier badge this week and earned a
                        $200 reward.
                      </span>
                    </div>
                  ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center gap-2 w-100 mt-5">
                      <h6 className="eclipse-winners-text mb-0">
                        🍀 Good luck next time! 🍀
                      </h6>
                      <span className="eclipse-winners-desc">
                        Make sure to complete all the tasks to boost your weekly
                        experience
                      </span>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {leaderboardData?.map((item, index) => (
                    <div
                      key={index}
                      className="leaderboard-item d-flex align-items-center justify-content-between px-3 py-2"
                    >
                      <div className="d-flex align-items-center gap-2 col-4">
                        {/* <div className="name-holder d-flex align-items-center justify-content-center">
                          <span className="name-initial">
                            {item.slice(0, 1)}
                          </span>
                        </div> */}
                        <div className="d-flex flex-column">
                          <h6
                            className="player-name mb-0"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {shortAddress(item)}
                          </h6>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-2 justify-content-end col-4">
                        <img src={usdt} alt="" />
                        <span className="player-usdt-amount">
                          {leaderboard === "azure" ? "$5" : "$10"}
                        </span>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressView;
